import styled from '@emotion/styled'
import {
  Divider as AntdDivider,
  TextStylePreset,
  Typography
} from '@vivaldis/antd-ui'
import { useTheme } from '@vivaldis/ui'
import { ReactNode } from 'react'

export interface InformationSectionHeaderProps {
  children: ReactNode
  showDivider?: boolean
  smallDivider?: boolean
}

export const InformationSectionHeader = ({
  children,
  showDivider = false,
  smallDivider = true
}: InformationSectionHeaderProps) => {
  const theme = useTheme()
  return (
    <>
      <Base>
        <Typography.Text
          preset={TextStylePreset.Regular16}
          color={theme.gray7}
          textAlign="left"
        >
          {children}
        </Typography.Text>
      </Base>
      {showDivider ? <Divider smallDivider={smallDivider} /> : null}
    </>
  )
}

const Base = styled('div')`
  display: flex;
  margin-bottom: 8px;
`

interface DividerProps {
  smallDivider?: boolean
}

const Divider = styled(AntdDivider, {
  shouldForwardProp: prop => prop !== 'smallDivider'
})<DividerProps>`
  border-top: 1px solid ${props => props.theme.gray4};
  ${props => (props.smallDivider ? 'margin: 8px 0;' : '')}
`
